import { CommonModule } from '@angular/common';
import { Component, ElementRef, ViewChild } from '@angular/core';
import { RouterLink } from '@angular/router';

import { Subject, takeUntil } from 'rxjs';

import { IonicModule, MenuController, NavController } from '@ionic/angular';

import { addIcons } from 'ionicons';

import { chevronDownOutline, closeOutline } from 'ionicons/icons';

import { Brand } from 'src/app/interfaces/Brand';
import { Expand } from 'src/app/interfaces/components/elements/Button';
import { ButtonComponent } from '../elements/button/button.component';

import { BaseDataService } from 'src/app/services/components/base-data.service';
import { UtilsService } from 'src/app/services/utils.service';
import { FranchiseeFormPage } from 'src/app/modals/franchisee-form/franchisee-form.page';
import { ModalService } from 'src/app/services/utils/modal/modal.service';

@Component({
  selector: 'app-menu',
  templateUrl: './menu.component.html',
  styleUrls: ['./menu.component.scss'],
  standalone: true,
  imports: [CommonModule, RouterLink, IonicModule, ButtonComponent],
})
export class MenuComponent {
  private readonly hiddenBrandTabs = new Set(['pizzaria-spoleto']);

  public Expand = Expand;
  public readonly pages = [
    { title: 'Início', label: 'home', url: '/inicio' },
    { title: 'Quem Somos', label: 'us', url: '/quem-somos' },
    { title: 'Blog Trigo', label: 'blog', url: '/blog-trigo' },
    { title: 'Seja Fornecedor', label: 'supplier', url: '/seja-fornecedor' },
    // { title: 'Jogo Interativo', label: 'game', url: '/jogo-interativo' },
    {
      title: 'Trabalhe Conosco',
      label: '',
      url: '/trabalhe-conosco',
      subItem: [
        {
          title: 'Vagas Grupo Trigo',
          label: 'separator',
          url: 'https://grupotrigo.gupy.io/',
        },
        {
          title: 'Vagas Gurumê Escritório',
          label: '',
          url: 'https://gurume.gupy.io/',
        },
        {
          title: 'Vagas Operacionais',
          label: '',
          url: ' https://grupotrigo.pandape.infojobs.com.br',
        },
      ],
    },
  ];

  public brands!: Brand[];

  private destroy$ = new Subject<void>();

  @ViewChild('accordionContent', { static: false })
  accordionContent!: ElementRef;

  public isAccordionOpen: boolean = false;

  constructor(
    private baseDataService: BaseDataService,
    private utilsService: UtilsService,
    private navController: NavController,
    private modalService: ModalService,
    private menuController: MenuController
  ) {
    addIcons({ chevronDownOutline, closeOutline });

    this.baseDataService.baseData$
      .pipe(takeUntil(this.destroy$))
      .subscribe((data) => {
        if (data) {
          this.brands = data.brands.filter((brand) => this.isVisibleBrand(brand.tab));
        }
      });
  }

  public toggleAccordion(): void {
    this.isAccordionOpen = !this.isAccordionOpen;

    const accordion = this.accordionContent.nativeElement;

    if (accordion) {
      const list = accordion.childNodes[0];
      const contentHeight = list.scrollHeight;

      if (!this.isAccordionOpen) {
        list.style.height = `${contentHeight}px`;
        setTimeout(() => {
          list.style.height = '0px';
        }, 5);
      } else {
        list.style.height = '0px';
        setTimeout(() => {
          list.style.height = `${contentHeight}px`;
        }, 5);
      }
    }
  }

  public navigate(id: string, path: string): void {
    if (id) {
      this.utilsService.setStorage('franchisee', id);
      this.navController.navigateForward(`/franquias/${path}`);
    }
  }

  public async openFranchiseeForm(): Promise<void> {
    this.utilsService.trackFranchiseeEntryCta('menu', {
      interaction_type: 'modal',
    });

    try {
      await this.menuController.close('lateral-menu');
    } catch {}
    setTimeout(() => {
      this.modalService.openModal('franchisee-form', 'franchisee-form', FranchiseeFormPage);
    }, 0);
  }

  private isVisibleBrand(tab: string): boolean {
    return !this.hiddenBrandTabs.has(tab);
  }
}
